<template>
  <form id="client-review-form"
        action="#"
        @submit.prevent="">
    <div class="form-group relative">
      <input type="text"
             name="name"
             @click="clearFormErrors('name')"
             class="form-control"
             :placeholder="Lang.get('common.name')"
             v-model="form.name"
      >
      <span class="help is-danger text-danger"
            v-if="form.errors.has('name')"
            v-text="form.errors.get('name')">
            </span>
    </div>
    <div class="form-group relative">
      <textarea type="text"
                name="textReview"
                @click="clearFormErrors('text')"
                class="form-control"
                :placeholder="Lang.get('common.review_text')"
                v-model="form.text"
      ></textarea>
      <span class="help is-danger text-danger"
            v-if="form.errors.has('text')"
            v-text="form.errors.get('text')">
            </span>
    </div>
    <input class="discount-button orange my-button"
           style="border: none"
           type="submit"
           @click="onSubmit"
           :disabled="isDisabled"
           :value="Lang.get('common.send')">
    <widget-loading v-if="form.loading" color="#03a9f4"></widget-loading>
  </form>
</template>

<script>
    import WidgetLoading from '../elements/WidgetLoading';

    export default {
        name: "form-client-review",
        components: {
            WidgetLoading,
        },
        data() {
            return {
                form: new Form({
                        name: '',
                        text: '',
                        published: 0,
                        language: Lang.locale
                    },
                    true
                ),
                isDisabled: false,
                Lang,
            }
        },
        methods: {
            clearFormErrors(name) {
                this.form.errors.clear(name);
                if (!this.form.errors.any()) {
                    this.isDisabled = false;
                }
            },
            onSubmit() {
                this.isDisabled = true;
                let prefix = Lang.locale === 'ru' ? '/ru' : '/';
                let url = prefix + '/client-review/store';
                this.form.post(url).then(res => {
                    this.isDisabled = false;
                    document.querySelector('#client-review-form').innerHTML = res;
                }).catch(error => console.log(error));
            },
        },

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/FormClientReview.vue